var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-stage0"},[_c('ResultWrapper',{attrs:{"config":_vm.resultConfig,"result":_vm.score}},[_vm._v(" "+_vm._s(_vm.judgeDescription(_vm.score))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }